module.exports = __webpack_public_path__ + "assets/loadfail.3a3c5ff5.svg";